import React, { useState } from "react";
import styled from "@emotion/styled";
import { InView } from "react-intersection-observer";

import { is768Query } from "~/core/scripts/mediaquery-helper";

export const Wrapper = styled.div`
  width: 100%;
  background: #f9f9f9;
  padding: 1px 0;
`;

export const InnerWrapper = styled.div`
  width: 100%;
  display: flex;
  overflow: visible;
  max-width: 960px;
  margin: 0 auto 48px;
  flex-wrap: wrap;
  justify-content: flex-end;
  padding-top: 16px;
  align-items: center;
`;

export const StickyWrapper = styled.div`
  flex-basis: 100%;
  margin: 0 auto;
  top: 0px;
  z-index: 999;
  background: rgb(249, 249, 249);
  background: linear-gradient(
    0deg,
    rgba(249, 249, 249, 0) 0%,
    rgba(249, 249, 249, 1) 10%
  );

  padding: 20px 56px 12px 56px;

  ${({ theme }) => theme.breakpoints.sm.up} {
    flex-basis: 50%;
    padding: 72px 56px 72px 96px;
  }
  ${({ theme }) => theme.breakpoints.combined.xs.up} {
    top: 12vh;
  }
  ${({ theme }) => theme.breakpoints.combined.sm.up} {
    top: 22vh;
  }
`;

export const StoryItems = styled.div`
  flex-basis: 100%;

  ${({ theme }) => theme.breakpoints.sm.up} {
    flex-basis: 50%;
  }
`;

export const Sans = styled.p`
  font-family: ${({ theme }) => theme.fonts.sans} !important;
  line-height: 1.5;
  font-size: 18px;
`;

export const StoryItemWrapper = styled.div`
  opacity: ${(p) => (p.isActive ? 1 : 0.7)};
  transition: opacity 100ms;
  line-height: 1.5;
  font-size: 18px;

  padding-left: 15px;
  padding-right: 15px;
  ${({ theme }) => theme.breakpoints.sm.up} {
    padding-right: 35px;
  }

  margin-bottom: 50vh;

  &:first-of-type {
    margin-top: 0px;
    ${({ theme }) => theme.breakpoints.sm.up} {
      margin-top: 16px;
    }
  }
  &:last-of-type {
    margin-bottom: 44px;
  }
`;

export const CenterOnMobile = styled.div`
  margin: 12px 0;
  text-align: center;
  /* ResultBoardWrapper hehe */
  > figure {
    justify-content: center;
  }
  ${({ theme }) => theme.breakpoints.sm.up} {
    text-align: left;
    > figure {
      justify-content: flex-start;
    }
  }
`;

// export const StoryItem = ({ onEnterViewport, isActive, children }) => {
//   const onInViewChange = (inView, entry) => {
//     if (inView) {
//       onEnterViewport();
//     }
//   };

//   const isDesktop = is768Query();

//   return (
//     <InView
//       as={StoryItemWrapper}
//       threshold={isDesktop ? 0.8 : 0.4}
//       onChange={onInViewChange}
//       isActive={isActive}
//     >
//       {children}
//     </InView>
//   );
// };

export const BoardTitle = styled.h4`
  font-weight: bold;
  font-size: 18px;
  margin: 12px 0;
`;

export const FinalResults = styled.div`
  margin: 48px 0;
  text-align: center;

  line-height: 1.5;
  font-size: 18px;
`;

export const HousesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;
  margin-bottom: 24px;
`;

export const HouseContainer = styled.div`
  flex-grow: 0;
  flex-basis: 32px;
  flex-shrink: 0;
  margin: 8px 0 12px;
  padding: 0 12px 0 0;
`;

export const TwoColumns = styled.div`
  display: flex;
  > * {
    flex-basis: 50%;
  }
`;

export const ResultNumber = styled.div`
  font-weight: bold;
  font-size: 20px;
  color: ${(p) =>
    p.isBiden ? p.theme.colors.democratic : p.theme.colors.republican};
`;

export const ElectorsTitle = styled.div`
  font-weight: bold;
  font-size: 14px;
`;

export const ElectorsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 24px;
`;
